/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_TitleInputs */

const cs_client_portal_title = /** @type {(inputs: Client_Portal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klientský portál`)
};

const en_client_portal_title = /** @type {(inputs: Client_Portal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client portal`)
};

/**
* | output |
* | --- |
* | "Client portal" |
*
* @param {Client_Portal_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_title = /** @type {((inputs?: Client_Portal_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_title(inputs)
	return cs_client_portal_title(inputs)
});